import React from 'react';
import { SectionHeading } from './SectionHeading';
import { VolumeCard } from './VolumeCard';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section id="volumes" className="defer-paint w-full scroll-mt-6 bg-white py-10 sm:py-20" aria-labelledby="volumes-heading" data-id="element-297" data-mp="coiy127hlxu5">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-298" data-mp="7p66431re0kp">
        <SectionHeading eyebrow="What you get: 6 complete volumes" titleId="volumes-heading" title={<>
              The Complete <span className="text-gold-text" data-id="element-300" data-mp="3c3wb27l2s26c">6-Volume</span>{' '}
              Coaching Library
            </>} lead={<>
              <span className="font-bold text-gold-text" data-id="element-301" data-mp="3pw2q1qchs347">150+</span>{' '}
              ready-to-run sessions · Progressions · Coaching cues
            </>} data-id="element-299" data-mp="7nlfgoikf1s4" />

        <ul className="mt-8 grid items-start gap-3 sm:mt-12 md:grid-cols-2 md:gap-4" data-id="element-302" data-mp="3l2hsfzet9b5j">
          {volumes.map(volume => <VolumeCard key={volume.number} volume={volume} data-id="element-303" data-mp="2sfnapa9dopvr" />)}
        </ul>
      </div>
    </section>;
}